export const GMAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_ID;

export const DEFAULT_MAP_CENTER = { lat: 53.3463247, lng: -6.263098 };
